import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';


const PreguntasFrecuentes = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "¿Envías a toda la República Mexicana?",
      answer: "Tenemos convenios con grandes transportistas que abarcan gran parte del País, si desaseas conocer si llegamos a tu ciudad envíanos tu CP."
    },
    {
      question: "¿Cuáles son sus tiempos de producción?",
      answer: "Nuestro compromiso es el cuarto día colocarlo en el transporte."
    },
    {
      question: "¿Tienes telas PREMIUM? ",
      answer: "Contamos con telas Europeas marca VERTILUX  con Certificaciones internacionales para proyectos especiales o gustos exigentes."
    },
    {
      question: "¿Tienes algún modelo inovador en el mercado? ",
      answer: "Contamos con la importación de tejidos y maquinaria para lograr un precio COMPETITIVO en el mercado con nuestra PERSIANA PERTINA búscala en la sección de modelos."
    },
    {
      question: "¿Tienes combinación de colores en los accesorios para las persianas? ",
      answer: "Tenemos 5 colores en accesorios en el armado de tus persianas y puedan combinar con los espacios del cliente, tenemos el color gris, chocolate, negro, blanco , Ivory y negro."
    },
    {
      question: "¿Manejas precios especiales para exhibiciones?",
      answer: "Apoyamos a nuestros Socios comerciales con descuentos para que puedan sus clientes finales ver nuestra calidad de insumos."
    }
  ];

  return (
    <motion.div
    initial={{opacity: .6, scale: .7}}
    whileInView={{ opacity: 1, scale: 1, delay: 0.3 }}>
      <FAQContainer>
      <h2>Preguntas Frecuentes</h2>
      {faqData.map((item, index) => (
        <motion.div
           whileHover={{ scale: 1.1 }}
           whileTap={{ scale: 0.95 }}>
        <FAQItem key={index}>
          
            <Question onClick={() => toggleFAQ(index)}>
            {item.question}
            <Icon isOpen={activeIndex === index}>+</Icon>
          </Question>
          
          <Answer isOpen={activeIndex === index}>
            {item.answer}
          </Answer>
        </FAQItem>
          </motion.div>
      ))}
      </FAQContainer>
    </motion.div>
    
  );
};

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  
  h2 {
    margin-bottom: 20px;
  }
`;

const FAQItem = styled.div`
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
`;

const Question = styled.div`
  padding: 15px 20px;
  background-color: #f8f8f8;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e9e9e9;
  }
`;

const Answer = styled.div`
  padding: 0 20px;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: white;
  opacity: 0;
  
  ${({ isOpen }) => isOpen && css`
    padding: 20px;
    max-height: 500px;
    opacity: 1;
  `}
`;

const Icon = styled.span`
  transition: transform 0.3s ease;
  
  ${({ isOpen }) => isOpen && css`
    transform: rotate(45deg);
  `}
`;
export default PreguntasFrecuentes;